import { render, staticRenderFns } from "./Vsat.vue?vue&type=template&id=a9c7b670&scoped=true"
import script from "./Vsat.vue?vue&type=script&lang=js"
export * from "./Vsat.vue?vue&type=script&lang=js"
import style0 from "./Vsat.vue?vue&type=style&index=0&id=a9c7b670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c7b670",
  null
  
)

export default component.exports